import React, { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import { config } from '../../config';

export default function NettoyagePosts() {
    const [stats, setStats] = useState({
        total_avant: 0,
        total_apres: 0,
        supprimes: 0,
        dernier_nettoyage: null
    });
    const [nettoyageAuto, setNettoyageAuto] = useState(true);
    const [loading, setLoading] = useState(false);

    // Utilisation de la configuration centralisée
    const API_BASE = `${config.apiBase}/technicien`;

    const nettoyerPosts = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${API_BASE}/nettoyer_posts.php`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ garder: 50 })
            });
            const data = await response.json();
            
            if (data.success) {
                setStats({
                    total_avant: data.total_avant,
                    total_apres: data.total_apres,
                    supprimes: data.supprimes,
                    dernier_nettoyage: new Date().toLocaleString()
                });
                toast.success(`Nettoyage effectué : ${data.supprimes} posts supprimés`);
            } else {
                toast.error(data.message);
            }
        } catch (error) {
            toast.error('Erreur lors du nettoyage');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        let interval;
        if (nettoyageAuto) {
            nettoyerPosts();
            interval = setInterval(nettoyerPosts, 10 * 60 * 1000);
        }
        return () => {
            if (interval) clearInterval(interval);
        };
    }, [nettoyageAuto]);

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 p-6">
            <div className="mx-auto max-w-4xl">
                {/* Header */}
                <div className="mb-8 rounded-2xl bg-gradient-to-r from-purple-600 to-indigo-600 p-6 text-white shadow-xl">
                    <h1 className="text-2xl font-bold">🧹 Nettoyage automatique des posts</h1>
                    <p className="mt-2 opacity-90">
                        Supprime automatiquement les anciens posts pour éviter la saturation du serveur
                    </p>
                </div>

                {/* Configuration */}
                <div className="mb-6 rounded-xl bg-white p-6 shadow-lg">
                    <div className="flex items-center justify-between">
                        <div>
                            <h2 className="text-lg font-semibold text-slate-800">⚙️ Configuration</h2>
                            <p className="text-sm text-slate-500">
                                Nettoyage automatique toutes les 10 minutes (garde les 50 derniers posts)
                            </p>
                        </div>
                        <label className="relative inline-flex cursor-pointer items-center">
                            <input
                                type="checkbox"
                                checked={nettoyageAuto}
                                onChange={(e) => setNettoyageAuto(e.target.checked)}
                                className="peer sr-only"
                            />
                            <div className="peer h-6 w-11 rounded-full bg-slate-200 after:absolute after:left-[2px] after:top-[2px] after:h-5 after:w-5 after:rounded-full after:border after:border-slate-300 after:bg-white after:transition-all after:content-[''] peer-checked:bg-purple-600 peer-checked:after:translate-x-full peer-checked:after:border-white peer-focus:outline-none"></div>
                            <span className="ml-3 text-sm font-medium text-slate-700">
                                {nettoyageAuto ? 'Activé' : 'Désactivé'}
                            </span>
                        </label>
                    </div>
                </div>

                {/* Statistiques */}
                <div className="mb-6 grid grid-cols-1 gap-4 md:grid-cols-3">
                    <div className="rounded-xl bg-gradient-to-br from-blue-500 to-blue-600 p-5 text-white shadow-lg">
                        <p className="text-sm opacity-90">Posts avant nettoyage</p>
                        <p className="text-3xl font-bold">{stats.total_avant || 0}</p>
                    </div>
                    <div className="rounded-xl bg-gradient-to-br from-red-500 to-red-600 p-5 text-white shadow-lg">
                        <p className="text-sm opacity-90">Posts supprimés</p>
                        <p className="text-3xl font-bold">{stats.supprimes || 0}</p>
                    </div>
                    <div className="rounded-xl bg-gradient-to-br from-green-500 to-green-600 p-5 text-white shadow-lg">
                        <p className="text-sm opacity-90">Posts restants</p>
                        <p className="text-3xl font-bold">{stats.total_apres || 0}</p>
                    </div>
                </div>

                {/* Infos et action manuelle */}
                <div className="rounded-xl bg-white p-6 shadow-lg">
                    <div className="mb-4 flex items-center justify-between">
                        <div>
                            <p className="text-sm text-slate-500">
                                Dernier nettoyage : {stats.dernier_nettoyage || 'Jamais'}
                            </p>
                        </div>
                        <button
                            onClick={nettoyerPosts}
                            disabled={loading}
                            className="rounded-lg bg-purple-600 px-4 py-2 text-white transition hover:bg-purple-700 disabled:opacity-50"
                        >
                            {loading ? 'Nettoyage...' : 'Nettoyer maintenant'}
                        </button>
                    </div>
                    
                    <div className="rounded-lg bg-amber-50 p-4">
                        <p className="text-sm text-amber-800">
                            ℹ️ Cette page reste ouverte pour maintenir le nettoyage automatique actif.
                            Les 50 posts les plus récents sont conservés, les plus anciens sont supprimés.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}